import React, { Fragment, useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData, postData } from '../../../apiService';
import { faL } from '@fortawesome/free-solid-svg-icons';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import CircularProgress from '@mui/material/CircularProgress';
import AsyncSelect from 'react-select/async';

const PurchaseDetails = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL    
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, userId, permissions, token, logout, branchstate } = useAuth();
    const branchId = 0;


    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, branchId, token, logout]);


    const [formData, setFormData] = useState([]);
    const [invoicedeatils, setInvoicedeatils] = useState([]);

    useEffect(() => {
        fetchData('PurchaseApi', `/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.Purchase);
                    setInvoicedeatils(response.response_data.PurchaseDetails);
                }
            })
            .catch((error) => {
                console.error('Error fetching Purchase Details:', error);
            });
    }, [id]);


    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };


    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto">

                <style>
                    {`
                        /* Hide scrollbar for Chrome, Safari, and Opera */
                        .container::-webkit-scrollbar {
                        width: 0.2em;
                        }

                        .container::-webkit-scrollbar-track {
                        background: rgba(255,255,255,0);
                        }

                        .container::-webkit-scrollbar-thumb {
                        background-color: rgba(255,255,255,0);
                        border-radius: 4px;
                        }
                    `}
                </style>

                <div className="w-full mb-2 flex">
                    <h6 className="block uppercase tracking-wide text-black productHead flex-grow linkcolor" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}> Purchase - Details</h6>

                    <Button
                        variant="contained"
                        color="error"
                        component={Link}
                        to="/PurchaseIndex"
                        className="linkcolor"
                        style={{ marginLeft: '8px' }}
                    >
                        BACK
                    </Button>

                </div>


                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                {successMessage && <p className="text-green-500">{successMessage}</p>}

                <div className="w-full mb-4 flex">
                    <div className="container mx-auto mt-2 p-4 max-w-screen-md bg-tabcolor rounded-lg shadow-lg p-6" style={{ marginTop: '10px', backgroundColor: 'rgba(255, 255, 255, 0.5)', maxHeight: '500px', overflowY: 'auto', width: '100%' }}>
                        <div className="w-full mb-4 flex" style={{ marginTop: '-1%' }}>
                            <div className="container mx-auto mt-2 p-4 max-w-screen-md bg-tabcolor rounded-lg shadow-lg p-6" style={{ marginTop: '10px', backgroundColor: 'rgba(255, 255, 255, 0.5)', maxHeight: '500px', overflowY: 'auto', width: '95%' }}>

                                <div className="w-full mb-2 flex" style={{ marginTop: '-1.50%' }}>

                                    <div className="w-2/4 mr-2">
                                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                            Supplier
                                            <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                            value={formData.SupplierName}
                                            type="text"
                                            placeholder="SupplierName"
                                            name='SupplierName'
                                            readOnly
                                        />
                                    </div>

                                    <div className="w-1/4 mr-2">
                                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                            Invoice Type
                                            <span className="text-red-500">*</span>
                                        </label>

                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                            value={formData.InvoiceTypeName}
                                            type="text"
                                            placeholder="InvoiceTypeName"
                                            name='InvoiceTypeName'
                                            readOnly
                                        />

                                    </div>

                                    <div className="w-1/4 mr-2">
                                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                            GST Number
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                            value={formData.GSTNumber}
                                            type="text"
                                            placeholder="GSTNumber"
                                            name='GSTNumber'
                                            readOnly
                                        />
                                    </div>

                                    <div className="w-1/4 mr-2">
                                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                            Bill Date
                                            <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                            value={formatDateForInput(formData.BillDate)}
                                            type="date"
                                            name='BillDate'
                                            disabled
                                        />
                                    </div>

                                    <div className="w-1/4 mr-2">
                                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                            Bill Number
                                            <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                            value={formData.BillNumber}
                                            type="text"
                                            placeholder="Bill Number"
                                            name='BillNumber'
                                            readOnly
                                        />
                                    </div>

                                </div>

                                <div className="w-full mb-2 flex">

                                    <div className="w-1/4 mr-2">
                                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                            Amount
                                            <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                            value={formData.Amount}
                                            type="text"
                                            placeholder="Amount"
                                            style={{ textAlign: 'right' }}
                                            name='Amount'
                                            readOnly
                                        />
                                    </div>

                                    <div className="w-1/4 mr-2">
                                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                            CGST
                                            <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                            value={formData.CGSTAmount}
                                            type="text"
                                            placeholder="CGST Amount"
                                            style={{ textAlign: 'right' }}
                                            name='CGSTAmount'
                                            readOnly
                                        />
                                    </div>

                                    <div className="w-1/4 mr-2">
                                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                            SGST
                                            <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                            value={formData.SGSTAmount}
                                            type="text"
                                            placeholder="SGST Amount"
                                            style={{ textAlign: 'right' }}
                                            name='SGST Amount'
                                            readOnly
                                        />
                                    </div>

                                    <div className="w-1/4 mr-2">
                                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                            IGST
                                            <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                            value={formData.IGSTAmount}
                                            type="text"
                                            placeholder="IGST Amount"
                                            style={{ textAlign: 'right' }}
                                            name='IGSTAmount'
                                            readOnly
                                        />
                                    </div>

                                    <div className="w-1/4 mr-2">
                                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                            Discount
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                            value={formData.DiscountAmount}
                                            type="text"
                                            placeholder="Discount"
                                            style={{ textAlign: 'right' }}
                                            name='DiscountAmount'
                                            readOnly
                                        />
                                    </div>


                                    <div className="w-1/4 mr-2">
                                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                            Freight
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                            value={formData.Freight}
                                            type="text"
                                            placeholder="Freight"
                                            style={{ textAlign: 'right' }}
                                            name='Freight'
                                            readOnly
                                        />
                                    </div>

                                    <div className="w-1/4 mr-2">
                                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                            Round Off
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                            value={formData.RoundOff}
                                            type="text"
                                            placeholder="RoundOff"
                                            style={{ textAlign: 'right' }}
                                            name='RoundOff'
                                            readOnly
                                        />
                                    </div>



                                </div>
                                <div className="w-full mb-4 flex">
                                    <div className="w-3/4 mr-2">
                                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                            Remarks
                                            <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                            value={formData.Remarks}
                                            type="text"
                                            placeholder="Enter Remarks"
                                            name='Remarks'
                                            readOnly
                                        />
                                    </div>

                                    <div className="w-1/4 mr-2">
                                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                            Total Amount
                                            <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                            value={formData.TotalAmount}
                                            type="number"
                                            placeholder="Total Amount"
                                            name='TotalAmount'
                                            readOnly
                                            style={{ textAlign: 'right' }}
                                        />
                                    </div>


                                    <div className="w-1/4 mr-2">
                                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                            Paid Amount
                                            <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                            value={formData.PaidAmount}
                                            type="number"
                                            placeholder="Paid Amount"
                                            name='PaidAmount'
                                            style={{ textAlign: 'right' }}
                                            max={formData.TotalAmount}
                                            readOnly
                                        />
                                    </div>

                                    <div className="w-1/4 mr-2">
                                        <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                            Balance Amount
                                            <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                            value={formData.BlanceAmount}
                                            type="text"
                                            placeholder="Blance Amount"
                                            name='BlanceAmount'
                                            readOnly
                                            style={{ textAlign: 'right' }}
                                        />
                                    </div>

                                </div>
                                <div className="w-full mb-2 flex" style={{ marginTop: '-1%' }}>
                                    <div className="w-full mb-2 flex">
                                        <TableContainer component={Paper}>
                                            <table className="table">
                                                <thead>
                                                    <tr style={{ backgroundColor: '#CDE69A' }}>
                                                        <th style={{ padding: '4px', backgroundColor: '#296073', color: 'white' }}>Item Name</th>
                                                        <th style={{ padding: '4px', backgroundColor: '#296073', textAlign: 'center', color: 'white' }}>Quantity</th>
                                                        <th style={{ padding: '4px', backgroundColor: '#296073', textAlign: 'right', color: 'white' }}>Rate</th>
                                                        <th style={{ padding: '4px', backgroundColor: '#296073', textAlign: 'right', color: 'white' }}>Amount</th>
                                                        <th style={{ padding: '4px', backgroundColor: '#296073', textAlign: 'right', color: 'white' }}>GST</th>
                                                        <th style={{ padding: '4px', backgroundColor: '#296073', textAlign: 'right', color: 'white' }}>Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {invoicedeatils.map((invdetail, index) => (
                                                        <tr key={index} className={invdetail.ColorCode === '#ffffff' ? 'white-row' : ''} style={{ width: '100%' }}>
                                                            <td style={{ padding: '4px', fontSize: '14px', width: '55%' }}>{invdetail.ItemName}</td>
                                                            <td style={{ padding: '4px', fontSize: '14px', width: '9%', textAlign: 'center' }}>
                                                                <label style={{ marginTop: '9px', color: 'black' }}>
                                                                    {invdetail.Quantity}
                                                                </label>
                                                            </td>
                                                            <td style={{ padding: '4px', fontSize: '14px', width: '9%', textAlign: 'right' }}>
                                                                <label style={{ marginTop: '9px', color: 'black' }}>
                                                                    {invdetail.Rate}
                                                                </label>
                                                            </td>
                                                            <td style={{ padding: '4px', fontSize: '14px', width: '9%', textAlign: 'right' }}>
                                                                <label style={{ marginTop: '9px', color: 'black' }}>
                                                                    {invdetail.Amount}
                                                                </label>
                                                            </td>
                                                            <td style={{ padding: '4px', fontSize: '14px', width: '9%', textAlign: 'right' }}>
                                                                <label style={{ marginTop: '9px', color: 'black' }}>
                                                                    {parseFloat(invdetail.CGSTAmount) + parseFloat(invdetail.SGSTAmount)}
                                                                </label>
                                                            </td>
                                                            <td style={{ padding: '4px', fontSize: '14px', width: '9%', textAlign: 'right' }}>
                                                                <label style={{ marginTop: '9px', color: 'black' }}>
                                                                    {invdetail.TotalAmount}
                                                                </label>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </TableContainer>

                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>
                </div>
            </div >
        </Fragment >

    );
};

export default PurchaseDetails;